export default __webpack_public_path__ + "static/media/bg_announcement.87df3acf.png";